<template>
  <v-app-bar app class="nav-fixed" :hide-on-scroll="!isMobile" flat height="54">
    <!-- 手机端导航栏 -->
    <div class="d-md-block d-none nav-container elShowWhenMobile">
      <div class="float-left blog-title">
        <div class="top-seayouth-container">
          <router-link to="/">
            {{ blogInfo.webSite.author }}
            <span class="navBlogId">{{
              blogInfo.user == null ? "" : " #" + blogInfo.user.id
            }}</span>
          </router-link>
        </div>
        <div class="top-switch-container">
          <v-checkbox
            class="pt-3 top-switch"
            v-model="themeValue"
            @change="themeCheck()"
            color="rgba(0, 0, 0, 0.54)"
            off-icon="mdi mdi-weather-sunny"
            on-icon="mdi mdi-weather-night"
          ></v-checkbox>
          <v-checkbox
            class="pt-3 top-switch"
            v-model="simplifyValue"
            @change="simplifyCheck()"
            color="rgba(0, 0, 0, 0.54)"
            off-icon="mdi mdi-table-large"
            on-icon="mdi mdi-table"
          ></v-checkbox>
          <v-btn class="top-switch" large icon @click="clickBgSoundSetting()">
            <v-icon small>{{
              $store.state.isPlayBgSound
                ? "mdi mdi-music-note"
                : "mdi mdi-music-note-off"
            }}</v-icon>
          </v-btn>
          <router-link to="/setting">
            <v-btn class="top-switch" large icon>
              <v-icon small>el-icon-setting</v-icon>
            </v-btn>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 电脑导航栏 -->
    <div class="d-md-block d-none nav-container elShowWhenWeb">
      <div class="float-left blog-title">
        <div class="top-seayouth-container">
          <router-link to="/">
            {{ blogInfo.webSite.author }}
            <span class="navBlogId">{{
              blogInfo.user == null ? "" : " #" + blogInfo.user.id
            }}</span>
          </router-link>
        </div>
        <div class="top-switch-container">
          <v-checkbox
            class="pt-3 top-switch"
            v-model="themeValue"
            @change="themeCheck()"
            color="rgba(0, 0, 0, 0.54)"
            off-icon="mdi mdi-weather-sunny"
            on-icon="mdi mdi-weather-night"
          ></v-checkbox>
          <v-checkbox
            class="pt-3 top-switch"
            v-model="simplifyValue"
            @change="simplifyCheck()"
            color="rgba(0, 0, 0, 0.54)"
            off-icon="mdi mdi-table-large"
            on-icon="mdi mdi-table"
          ></v-checkbox>
          <v-btn class="top-switch" large icon @click="clickBgSoundSetting()">
            <v-icon class="top-switch-btn" small>{{
              $store.state.isPlayBgSound
                ? "mdi mdi-music-note"
                : "mdi mdi-music-note-off"
            }}</v-icon>
          </v-btn>
          <router-link to="/setting">
            <v-btn class="top-switch" large icon>
              <v-icon class="top-switch-btn" small>el-icon-setting</v-icon>
            </v-btn>
          </router-link>
        </div>
      </div>
      <div class="float-right nav-title">
        <!-- <div class="menus-item">
          <a class="menu-btn" @click="openSearch">
            <i class="iconfont iconsousuo" /> 搜索
          </a>
        </div> -->
        <div
          class="menus-item"
          :class="{ simplifyClass: this.$store.state.isSimplify }"
        >
          <router-link class="menu-btn" to="/home" target="_self">
            <i class="iconfont mdi mdi-home" /> 首页
          </router-link>
        </div>
        <div class="menus-item item-with-expand">
          <a class="menu-btn">
            <router-link class="menu-btn" to="/ai/chatgpt" target="_self">
              <i class="iconfont mdi mdi-lightbulb" />
              <span :class="{ simplifyClass: this.$store.state.isSimplify }"
                >AI 问答</span
              >
            </router-link>
            <i
              class="iconfont mdi mdi-chevron-down expand"
              :class="{ simplifyClass: this.$store.state.isSimplify }"
            />
          </a>
          <ul
            class="menus-submenu"
            :class="{ simplifyVisiableClass: this.$store.state.isSimplify }"
          >
            <li>
              <router-link
                class="menu-btn-child"
                to="/ai/chatgpt/display"
                target="_self"
              >
                <i class="iconfont mdi mdi-view-dashboard" /> GPT 问答广场
              </router-link>
            </li>
          </ul>
        </div>
        <div
          class="menus-item"
          :class="{ 'item-with-expand': this.$store.state.isSimplify }"
        >
          <a class="menu-btn">
            <router-link class="menu-btn" to="/ai/art" target="_self">
              <i class="iconfont mdi mdi-brush" /><span
                :class="{ simplifyClass: this.$store.state.isSimplify }"
              >
                AI 绘画</span
              >
            </router-link>
            <!-- <i class="iconfont mdi mdi-chevron-down expand" :class="{simplifyClass: this.$store.state.isSimplify}" /> -->
          </a>
          <!-- <ul class="menus-submenu"  :class="{simplifyVisiableClass: this.$store.state.isSimplify}">
            <li>
              <router-link
                class="menu-btn-child"
                to="/ai/art/display"
                target="_self"
              >
                <i class="iconfont mdi mdi-image-area" /> AI 画作广场
              </router-link>
            </li>
          </ul> -->
        </div>
        <div class="menus-item item-with-expand">
          <a class="menu-btn">
            <router-link class="menu-btn" to="/ai/audio" target="_self">
              <i class="iconfont mdi mdi-music-circle" /><span
                :class="{ simplifyClass: this.$store.state.isSimplify }"
              >
                AI 音频</span
              >
            </router-link>
            <i
              class="iconfont mdi mdi-chevron-down expand"
              :class="{ simplifyClass: this.$store.state.isSimplify }"
            />
          </a>
          <ul
            class="menus-submenu"
            :class="{ simplifyVisiableClass: this.$store.state.isSimplify }"
          >
            <li>
              <router-link
                class="menu-btn-child"
                to="/ai/audio/display"
                target="_self"
              >
                <i class="iconfont mdi mdi-music-note" /> AI 音乐广场
              </router-link>
            </li>
          </ul>
        </div>
        <!-- <div class="menus-item">
          <router-link class="menu-btn" to="/links">
            <i class="iconfont iconlianjie" /> 友链
          </router-link>
        </div> -->
        <!-- <div class="menus-item">
          <router-link class="menu-btn" to="/about">
            <i class="iconfont iconzhifeiji" /> 关于
          </router-link>
        </div> -->
        <div
          class="menus-item item-with-expand"
          :class="{ simplifyClass: this.$store.state.isSimplify }"
        >
          <a class="menu-btn">
            <a href="/game/emulator" target="_self">
              <i class="iconfont mdi mdi-gamepad-variant" /> 游戏模拟器
            </a>
            <i class="iconfont mdi mdi-chevron-down expand" />
          </a>
          <ul class="menus-submenu">
            <li>
              <router-link
                class="menu-btn-child"
                to="/game/mygames"
                target="_self"
              >
                <i class="iconfont mdi mdi-briefcase-check" /> 我的游戏
              </router-link>
            </li>
            <li>
              <router-link
                class="menu-btn-child"
                to="/game/warehouse"
                target="_self"
              >
                <i class="iconfont mdi mdi-view-list" /> ROM库
              </router-link>
            </li>
          </ul>
        </div>
        <div
          class="menus-item"
          :class="{ simplifyClass: this.$store.state.isSimplify }"
        >
          <a class="menu-btn">
            <router-link class="menu-btn" to="/toolbox" target="_self">
              <i class="iconfont mdi mdi-wrench" /> 工具箱
            </router-link>
          </a>
        </div>
        <div
          class="menus-item"
          :class="{ 'item-with-expand': this.$store.state.isSimplify }"
        >
          <router-link class="menu-btn" to="/message">
            <i class="iconfont mdi mdi-comment-question-outline" /><span
              :class="{ simplifyClass: this.$store.state.isSimplify }"
            >
              留言</span
            >
          </router-link>
        </div>
        <div class="menus-item">
          <a
            class="menu-btn"
            v-if="!this.$store.state.userId"
            @click="openLogin"
          >
            <i class="iconfont mdi mdi-login" /> 登录
          </a>
          <template v-else>
            <img
              class="user-avatar"
              :src="this.$store.state.avatar"
              height="30"
              width="30"
            />
            <ul class="menus-submenu">
              <li>
                <router-link to="/user">
                  <i class="iconfont mdi mdi-account-circle" /> 个人中心
                </router-link>
              </li>
              <li>
                <router-link to="/log">
                  <i class="iconfont mdi mdi-chart-bar" /> 日志明细
                </router-link>
              </li>
              <li>
                <router-link to="/setting">
                  <i class="el-icon-setting" /> 设置
                </router-link>
              </li>
              <!-- <li>
                <router-link to="/myNotice">
                  <i class="iconfont mdi mdi-email-outline" /> 我的消息
                </router-link>
              </li> -->
              <li>
                <a @click="logout"
                  ><i class="iconfont mdi mdi-logout" /> 退出</a
                >
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { logout } from "../../api";

export default {
  mounted() {
    this.themeValue = localStorage.getItem("themeValue") == "true";
    this.themeCheck();
    this.simplifyValue = localStorage.getItem("simplifyValue") == "true";
    this.simplifyCheck();
    this.$store.state.bgSoundFlag = false;
    this.$store.state.isPlayBgSound = false;
    window.addEventListener("scroll", this.scroll);
  },
  data: function() {
    return {
      themeValue: false,
      simplifyValue: false,
      isBgSoundChildVisible: false,
    };
  },
  methods: {
    scroll() {
      const that = this;
      that.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
    showBgSoundChild() {
      // console.log("showBgSoundChild")
      this.isBgSoundChildVisible = true; // 显示子 div
    },
    hideBgSoundChild() {
      // console.log("hideBgSoundChild")
      this.isBgSoundChildVisible = false; // 隐藏子 div
    },
    // openSearch() {
    //   this.$store.state.searchFlag = true;
    // },
    openDrawer() {
      this.$store.state.drawer = true;
    },
    openLogin() {
      this.$store.state.loginFlag = true;
    },
    logout() {
      //如果在个人中心则跳回上一页
      if (this.$route.path === "/user") {
        this.$router.go(-1);
      }
      logout()
        .then((res) => {
          this.$store.commit("logout");
          this.$toast({
            type: "success",
            message: "注销成功",
          });
          this.reload();
        })
        .catch((err) => {
          this.$store.commit("logout");
          this.$toast({
            type: "success",
            message: "已退出",
          });
          this.reload();
        });
    },
    simplifyCheck() {
      // this.simplifyValue = !this.simplifyValue;
      // console.log("simplifyCheck:" + this.simplifyValue)
      this.$store.state.isSimplify = this.simplifyValue;
      localStorage.setItem("simplifyValue", this.simplifyValue);
    },
    themeCheck() {
      // this.themeValue = !this.themeValue;
      // console.log("themeValue:" + this.themeValue)
      localStorage.setItem("themeValue", this.themeValue);
      if (this.themeValue) {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    },
    clickBgSoundSetting() {
      // console.log("clickBgSoundSetting:" + this.$store.state.bgSoundFlag)
      this.$store.state.bgSoundFlag = !this.$store.state.bgSoundFlag;
    },
  },
  computed: {
    avatar() {
      return this.$store.state.avatar;
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
i {
  margin-right: 4px;
}

ul {
  list-style: none;
}

.nav {
  background: rgba(0, 0, 0, 0) !important;
}

.nav a {
  color: #eee !important;
}

.nav .menu-btn {
  text-shadow: 0.05rem 0.05rem 0.1rem rgba(0, 0, 0, 0.3);
}

.nav .menu-btn-child {
  text-shadow: 0.05rem 0.05rem 0.1rem rgba(0, 0, 0, 0.3);
}

.nav .blog-title a {
  text-shadow: 0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.15);
}

.theme--light.nav-fixed {
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.123),
    0px 2px 3px 0px rgba(0, 0, 0, 0.058), 0px 1px 4px 0px rgba(0, 0, 0, 0.047) !important;
}

.theme--dark.nav-fixed {
  background: rgba(18, 18, 18, 1) !important;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.945),
    0px 2px 3px 0px rgba(0, 0, 0, 0.94), 0px 1px 4px 0px rgba(0, 0, 0, 0.808) !important;
}

.theme--dark.nav-fixed a {
  color: rgba(255, 255, 255, 1) !important;
}

.theme--light.nav-fixed a {
  color: #4c4948 !important;
}

.navBlogId {
  font-size: 0.6em;
}

.nav-fixed .menus-item a,
.nav-fixed .blog-title a {
  text-shadow: none;
}

.nav-container {
  font-size: 14px;
  width: 100%;
  height: 100%;
}

.nav-mobile-container {
  width: 100%;
  display: flex;
  align-items: center;
}

.blog-title,
.nav-title {
  display: flex;
  align-items: center;
  height: 100%;
}

.blog-title a {
  font-size: 18px;
  font-weight: bold;
}

.menus-item {
  position: relative;
  display: inline-block;
  margin: 0 28px 0 28px;
}

.menus-item a {
  transition: all 0.2s;
}

.nav-fixed .menu-btn:hover {
  color: #49b1f5 !important;
}

.nav-fixed .menu-btn-child:hover {
}

.menu-btn:hover:after {
  width: 100%;
}

.menus-item a:after {
  position: absolute;
  bottom: -5px;
  left: 0;
  z-index: -1;
  width: 0;
  height: 3px;
  background-color: #80c8f8;
  content: "";
  transition: all 0.3s ease-in-out;
}

.user-avatar {
  cursor: pointer;
  border-radius: 50%;
  margin-top: 4px;
  object-fit: cover;
}

.menus-item:hover .menus-submenu {
  display: block;
}

.menus-submenu {
  position: absolute;
  display: none;
  right: 0;
  width: max-content;
  margin-top: 8px;
  box-shadow: 0 5px 20px -4px rgba(0, 0, 0, 0.5);
  background-color: #fff;
  animation: submenu 0.3s 0.1s ease both;
}

.menus-submenu:before {
  position: absolute;
  top: -8px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
}

.menus-submenu a {
  line-height: 2;
  color: #4c4948 !important;
  text-shadow: none;
  display: block;
  padding: 6px 14px;
}

.menus-submenu a:hover {
  background: #4ab1f4;
}

@keyframes submenu {
  0% {
    opacity: 0;
    filter: alpha(opacity=0);
    transform: translateY(10px);
  }

  100% {
    opacity: 1;
    filter: none;
    transform: translateY(0);
  }
}

.item-with-expand {
  margin-right: 4px !important;
}

.top-switch-container {
  height: 44px;
  margin-left: 18px;
  display: flex;
}

.top-switch :deep(.v-input--selection-controls__input .v-icon) {
  font-size: 18px !important;
}

.theme--dark .bg-sound-child-div {
  font-size: 14px !important;
  display: inline-block;
  height: 34px;
  width: 36px;
  position: relative;
  top: 7px;
  left: -11px;
  background-color: #343434;
  border: 0px solid #0d0d0d78;
  padding: 4px 4px 4px 4px;
  border-radius: 5px 20px 20px 5px;
}

.theme--light .bg-sound-child-div {
  /* z-index: -1; */
  font-size: 14px !important;
  display: inline-block;
  height: 34px;
  width: 36px;
  position: relative;
  top: 7px;
  left: -11px;
  background-color: #f0f0f0;
  border: 0px solid #ccc;
  padding: 4px 4px 4px 4px;
  border-radius: 5px 20px 20px 5px;
}

.bg-sound-child-div .v-icon {
  font-size: 16px !important;
}

/* Transition styles */
@keyframes axisX {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }

  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

.fade-enter-active {
  animation: axisX 0.4s;
}

.fade-leave-active {
  animation: axisX 0.4s reverse;
}

@media (min-width: 760px) {
  .top-switch {
    padding-left: 8px;
    padding-right: 8px;

    .top-switch-btn {
      margin: auto;
    }
  }

  .elShowWhenMobile {
    display: none !important;
  }

  .elShowWhenWeb {
    display: block !important;
  }
}

@media (max-width: 759px) {
  .blog-title {
    width: 100%;
  }

  .top-seayouth-container {
    width: 100%;
  }

  .top-switch-container {
    align-items: flex-start;
    flex-wrap: nowrap;
    justify-content: flex-end;
    width: 100%;
  }

  .top-switch {
    padding-left: 8px;
    padding-right: 8px;

    .top-switch-btn {
      margin: auto;
      top: 2px;
    }
  }

  .elShowWhenMobile {
    display: block !important;
  }

  .elShowWhenWeb {
    display: none !important;
  }
}
</style>
